<template>
  <div class="full-height tkRefundCmp linear-main3">
    <ld-header
      @click-left="goback"
      :transparent="true"
      :white="true"
    />
    <div class="pad-8">
      <!--  -->
      <div
        class="white"
      >
        <div class="pad-tb-20">
          <div class="font24 font-lg pad-b-5">
            <ld-icon
              :type="details.realOrderStatus!=1&&details.isShowApproval ? 'iconshenpi1' :
              details.isShowPay == 1 ? 'iconzhifu' :
              'icondingzuoshj-icon-Reser'"
              size="30"
              class="order-status__icon"
            />  {{ details.refundStatusRemark }}
          </div>
          <p v-show="details.isShowApproval != 1">
            退票申请已提交，请等待服务商办理！
          </p>
          <p v-show="details.isShowApproval == 1">
            退票申请已提交，请立即送审！
          </p>
        </div>
      </div>

      <!--内容区域-->
      <div
        class="pad-b-5"
      >
        <div class="pad-b-5">
          <van-cell>
            退票单号：{{ details.orderNo }}
            <span
              class="fr main-color"
              @click="lookRefundTicketDetail"
            >
              {{ $t('B011','查看订单') }}
            </span>
          </van-cell>
        </div>
        <div
          v-for="(info,index) in details.refundRangeList"
          :key="index"
        >
          <voyage :flight="info" />
        </div>
        <van-cell>
          {{ $t('C001','乘机人') }}：
          <span class="fr">{{ details.tkOrderPsgBean.psgName }}
            <van-tag
              type="danger"
              v-show="details.tkOrderPsgBean.fsEmpId"
            >
              {{ $t('attach','附') }}
            </van-tag>
          </span>
        </van-cell>
      </div>
      <!--  -->
      <ld-button
        detault
        :to="isYlslh5 ? '/tk/tkQuery' : '/home'"
      >
        {{ $t('B012','继续预订') }}
      </ld-button>
    </div>

    <!--  -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="bg-white full-width pad-lr-10 shadow"
        type="flex"
        align="center"
      >
        <van-col span="1" />
        <van-col span="12">
          <span class="font12">应退金额：</span>
          <span class="font12 red">&yen; </span>
          <span class="font16 red"> {{ details.cuRefundAmount }}</span>
          <!-- <span class="font10 gray"> {{ $t('E017','共') }}{{ detail.orderPsgBeanList.length }}人</span>  -->
        </van-col>
        <van-col span="3">
          <div
            class="font12 text-center"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006','明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </div>
        </van-col>
        <van-col
          span="8"
          v-if="details.isShowApproval==1"
        >
          <ld-button
            main
            size="md"
            @click="sendApply"
          >
            {{ $t('B028','送审') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
  </div>
</template>

<script>
import ldButton from 'Common/ldButton'
import { Cell , Field ,Checkbox ,Tag, Step, Steps} from 'vant'
import voyage from 'Components/tk/voyage/voyage.vue'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import Bussiness from 'Utils/business'
import defaultMixin from '@/business/mixins/default'

export default {
  template: 'tkRefundCmp',
  mixins:[defaultMixin],
  components: {
    ldButton,
    [Cell.name]:Cell,
    [Field.name]:Field,
    [Checkbox.name]:Checkbox,
    [Tag.name]:Tag,
    [Step.name]:Step,
    [Steps.name]:Steps,
    voyage,
    ldTabbar
  },
  data:function(){
    return {
      details:{}
    }
  },
  computed: {
    orderId(){
      return this.$route.query.orderId
    },
    priceList(){
      return [
        { name: '原票价', price: Math.abs(this.details.refundSalePrice) },
        { name: '退票价', price: this.details.refundSalePrice },
        { name: '退机建', price: this.details.refundAirportFee},
        { name: '退税费', price: this.details.refundTax},
        { name: '退票服务费', price: this.details.refundServiceFee},
        { name: '加收服务费', price: this.details.serviceFee},
        { name: '退票手续费', price: this.details.cuRefundPoundage},
        { name: '应退金额', price: this.details.cuRefundAmount},
      ]
    }
  },
  activated(){
    this.getRefundDetail()
  },
  created(){
    this.getRefundDetail()
  },
  methods:{
    // 继续预订
    goback(){
      this.$router.push({path:'/allorder'})
    },
    getRefundDetail(){
      this.$api['tkOrder/refundOrderDetail']({
        refundId: this.orderId
      }).then(res=>{
        let cache=res.data||{}
        this.details=cache
      })
    },
    //取消退票
    cancleRefundTicket(id){
      this.$api['tkOrder/refundCancel']({
        refundOrderId: id
      }).then(()=>{
        this.$toast('取消成功！')
        this.getRefundDetail()
      })
    },
    //查看 退票详情
    lookRefundTicketDetail(){
      this.$router.push({path:'/tk/tkRefundDetail',query:{orderId:this.details.refundId}})
    },
    //去送审
    sendApply() {
      this.details.orderType = '11002'
      Bussiness.ApprovalSend(this.details)
      // this.$router.push({path:'/approval/Send',query:{orderId:this.details.refundId,orderNo:this.details.orderNo,orderType:this.details.orderType}})
    },
    toggle(name){
      this.$refs[name].toggle()
    }
  }
}
</script>

<style lang="less" scoped>
.tkRefundCmp{
}
.pad-b-5{
    padding-bottom:5px;
}
.pad-8{
    padding:8px;
}
.pad-tb-20{
    padding-top:20px;
    padding-bottom:20px;
}
.pad-lr-20{
    padding-left: 20px;
    padding-right: 20px;
}
</style>
